// QueryState — estados consistentes de carga / error / vacío para queries.
// Evita que una página quede en blanco si la API falla (gap del review).
import type { ReactNode } from "react";
import { AlertCircle, Loader2 } from "lucide-react";

export function QueryState({
  isLoading,
  error,
  isEmpty,
  emptyTitle = "Sin datos todavía",
  emptyHint,
  emptyAction,
  children,
}: {
  isLoading?: boolean;
  error?: unknown;
  isEmpty?: boolean;
  emptyTitle?: string;
  emptyHint?: ReactNode;
  emptyAction?: ReactNode;
  children: ReactNode;
}) {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2 py-10 text-[14px] text-[var(--color-text-muted)]">
        <Loader2 className="animate-spin" size={16} /> Cargando…
      </div>
    );
  }
  if (error) {
    const msg = error instanceof Error ? error.message : "Ocurrió un error al cargar.";
    return (
      <div className="flex items-start gap-3 rounded-[var(--radius-xl)] border border-[var(--color-critical)]/30 bg-[var(--color-critical)]/10 px-4 py-3 text-[13px] text-[var(--color-critical)]">
        <AlertCircle size={16} className="mt-0.5 shrink-0" />
        <span>{msg}</span>
      </div>
    );
  }
  if (isEmpty) {
    return (
      <div className="vision-card-default flex flex-col items-center justify-center gap-3 rounded-[var(--radius-2xl)] px-6 py-14 text-center">
        <div className="text-[15px] font-semibold text-[var(--color-text-primary)]">{emptyTitle}</div>
        {emptyHint && <div className="max-w-md text-[13px] text-[var(--color-text-secondary)]">{emptyHint}</div>}
        {emptyAction}
      </div>
    );
  }
  return <>{children}</>;
}
